import React from 'react';

export default ({ color = '#221CB6', size = 12 }: { color: string, size: number }): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="6" fill={color} />
    <path
      d="M9 4.83328L6.45 7.38328L4.95 5.88328L3 7.83328"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.20036 4.83328H9.00036V6.63328"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
